import React from 'react';
import { Field } from 'redux-form';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import renderTextField from '../../_shared/utils/renderTextField';

const formatFirmFieldValue = value => (value === null || value === undefined ? '' : value);

const formatStateCode = value => {
  if (value === null || value === undefined) return '';
  return `${value}`.toUpperCase();
};

const useStyles = makeStyles(() => ({
  innerContainer: {
    backgroundColor: '#fff',
    borderRadius: '4px',
    boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)',
  },
}));

const ManageFirm = () => {
  const classes = useStyles();

  return (
    <Grid
      item
      container
      xs={12}
      sm={12}
      md={12}
      lg={12}
      spacing={2}
      alignItems="center"
      justify="center"
      className={classes.innerContainer}
    >
      {/* Firm Details section header */}
      <Grid item xs={12}>Firm Details</Grid>
      {/* Row 1: Firm Name */}
      <Grid item xs={12}>
        <Field
          name="extrn_company_name"
          component={renderTextField}
          format={formatFirmFieldValue}
          inputType="text"
          inputLabel="Firm Name"
          fullWidth
        />
      </Grid>
      {/* Address section header */}
      <Grid item xs={12}>Address</Grid>
      {/* Row 2: Address Line 1 | Address Line 2 */}
      <Grid item xs={6}>
        <Field
          name="extrn_addr_line1"
          component={renderTextField}
          format={formatFirmFieldValue}
          inputType="text"
          inputLabel="Address Line 1"
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <Field
          name="extrn_addr_line2"
          component={renderTextField}
          format={formatFirmFieldValue}
          inputType="text"
          inputLabel="Address Line 2"
          fullWidth
        />
      </Grid>
      {/* Row 3: City | State */}
      <Grid item xs={6}>
        <Field
          name="extrn_city_name"
          component={renderTextField}
          format={formatFirmFieldValue}
          inputType="text"
          inputLabel="City"
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <Field
          name="extrn_st_prov_cd"
          component={renderTextField}
          format={formatStateCode}
          inputType="text"
          inputLabel="State"
          fullWidth
        />
      </Grid>
      {/* Row 4: Zip (left column only) */}
      <Grid item xs={6}>
        <Field
          name="extrn_postal_cd"
          component={renderTextField}
          format={formatFirmFieldValue}
          inputType="text"
          inputLabel="Zip"
          fullWidth
        />
      </Grid>
      <Grid item xs={6} />
    </Grid>
  );
};

export default ManageFirm;
